import { EyeOff, Eye } from 'lucide-react';

export default function CategoryFilter({ categories, active, onToggle, onAll, hideDone, onHideDone }) {
  const allActive = active.size === 0;
  return (
    <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-none" data-testid="passport-category-filter">
      <button
        type="button"
        onClick={onAll}
        className={`shrink-0 h-9 px-3 rounded-full text-xs font-semibold border transition-colors ${allActive ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 border-gray-300'}`}
        data-testid="passport-filter-all"
      >
        Todos
      </button>
      {categories.map((c) => {
        const on = active.has(c.category);
        return (
          <button
            key={c.category}
            type="button"
            onClick={() => onToggle(c.category)}
            className={`shrink-0 h-9 pl-1.5 pr-3 rounded-full text-xs font-semibold border inline-flex items-center gap-1.5 transition-colors ${on ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 border-gray-300'}`}
            data-testid={`passport-filter-${c.category}`}
          >
            <span className="w-4 h-4 rounded-full border border-white/60" style={{ backgroundColor: c.color || '#9ca3af' }} />
            {c.category}
            <span className={on ? 'text-white/70' : 'text-gray-400'}>{c.verified}/{c.total}</span>
          </button>
        );
      })}
      <button
        type="button"
        onClick={onHideDone}
        className={`shrink-0 h-9 px-3 rounded-full text-xs font-semibold border inline-flex items-center gap-1 ${hideDone ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-gray-700 border-gray-300'}`}
        data-testid="passport-filter-hide-done"
      >
        {hideDone ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
        {hideDone ? 'Ocultando acreditados' : 'Ocultar acreditados'}
      </button>
    </div>
  );
}
